import { Controller } from "stimulus"

export default class extends Controller {

  initialize() {
    this.toggleClass = 'header--scrolled'
    this.lastScrollTop = 0
    this.delta = 15
  }

  toggle() {
    if (window.scrollY >= 90) {
      this.element.classList.add(this.toggleClass)
    } else {
      this.element.classList.remove(this.toggleClass)
    }
  }

  toggleReveal() {
    let currentScrollPosition = window.scrollY

     if (Math.abs(this.lastScrollTop - currentScrollPosition) <= this.delta) {
       return false
     } else if ((currentScrollPosition > this.lastScrollTop) && (this.lastScrollTop > 0)) {
       this.element.style = 'top: -8em'
     } else {
       this.element.style = 'top: 0'
    }

    if (currentScrollPosition < 20) {
      this.element.classList.remove(this.toggleClass)
    } else if (currentScrollPosition >= 150) {
      this.element.classList.add(this.toggleClass)
    }

    this.lastScrollTop = currentScrollPosition;
  }
}
